import { render, staticRenderFns } from "./AssetMediaForm.vue?vue&type=template&id=407f1062"
import script from "./AssetMediaForm.vue?vue&type=script&lang=js"
export * from "./AssetMediaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports